import { SET_SALE_SOURCE, RESET_SALE_SOURCE } from './constants';

export const setSaleSource = source => ({
  type: SET_SALE_SOURCE,
  payload: source,
});

export const resetSaleSource = () => ({
  type: RESET_SALE_SOURCE,
});
